module.exports = __webpack_public_path__ + "img/wb5@2x.66821ae6.png";